/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ConvocationResignationAcademicProgram model module.
 * @module model/ConvocationResignationAcademicProgram
 * @version 1.0.0
 */
class ConvocationResignationAcademicProgram {
    /**
     * Constructs a new <code>ConvocationResignationAcademicProgram</code>.
     * @alias module:model/ConvocationResignationAcademicProgram
     */
    constructor() { 
        
        ConvocationResignationAcademicProgram.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ConvocationResignationAcademicProgram</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ConvocationResignationAcademicProgram} obj Optional instance to populate.
     * @return {module:model/ConvocationResignationAcademicProgram} The populated <code>ConvocationResignationAcademicProgram</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ConvocationResignationAcademicProgram();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('official_code')) {
                obj['official_code'] = ApiClient.convertToType(data['official_code'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
ConvocationResignationAcademicProgram.prototype['id'] = undefined;

/**
 * @member {String} official_code
 */
ConvocationResignationAcademicProgram.prototype['official_code'] = undefined;






export default ConvocationResignationAcademicProgram;

